import React, { useState, useEffect, useCallback } from "react";
import imageCompression from "browser-image-compression";

export default function LaporanTab({
  supabase,
  house,
  styles,
  StatusBadge
}) {

  const [kategori, setKategori] = useState("");
  const [judul, setJudul] = useState("");
  const [deskripsi, setDeskripsi] = useState("");
  const [foto, setFoto] = useState("");
  const [uploading, setUploading] = useState(false);
  const [riwayat, setRiwayat] = useState([]);
  const [hiddenLaporan, setHiddenLaporan] = useState([]);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const hideLaporan = (itemId) => {
    setHiddenLaporan([...hiddenLaporan, itemId]);
  };

  const muatRiwayat = useCallback(async () => {
    try {
      setIsRefreshing(true);
      const { data, error } = await supabase
        .from("laporan_warga")
        .select("*")
        .eq("nomor_rumah", house.nomor_rumah)
        .order("id", { ascending: false });

      if (error) throw error;

      setRiwayat(data || []);

    } catch (err) {
      console.log(err);
      alert(JSON.stringify(err, null, 2));
    } finally {
      setIsRefreshing(false);
    }
  }, [supabase, house.nomor_rumah]);

  useEffect(() => {
    muatRiwayat();

    // Subscribe to real-time updates for laporan_warga
    const targetHouse = house.nomor_rumah;
    const channel = supabase
      .channel(`laporan-${targetHouse}`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "laporan_warga" },
        (payload) => {
          if (String(payload.new?.nomor_rumah || payload.old?.nomor_rumah).trim().toUpperCase() === String(targetHouse).trim().toUpperCase()) {
            muatRiwayat();
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [muatRiwayat, house.nomor_rumah, supabase]);

  const handleUploadFoto = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);

    try {

      const options = {
        maxSizeMB: 0.2,
        maxWidthOrHeight: 800,
        useWebWorker: true
      };

      const compressedFile = await imageCompression(file, options);

      const ext = file.name.split(".").pop();

      const fileName =
        `laporan_${house.nomor_rumah.replace("/", "-")}_${Date.now()}.${ext}`;

      const { error: storageError } = await supabase.storage
        .from("laporan_foto")
        .upload(fileName, compressedFile);

      if (storageError) throw storageError;

      const { data } = supabase.storage
        .from("laporan_foto")
        .getPublicUrl(fileName);

      setFoto(data.publicUrl);

    } catch (err) {
      alert(err.message);
    }

    setUploading(false);
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!kategori || !judul || !deskripsi || !foto) {
      alert("Lengkapi semua data terlebih dahulu.");
      return;
    }

    try {

      const { error } = await supabase
        .from("laporan_warga")
        .insert([
          {
            nomor_rumah: house.nomor_rumah,
            nama_warga: house.nama,
            kategori,
            judul,
            deskripsi,
            foto,
            status: "Menunggu"
          }
        ]);

      if (error) throw error;

      setKategori("");
      setJudul("");
      setDeskripsi("");
      setFoto("");

      muatRiwayat();

    } catch (err) {
      alert(err.message);
    }

  };

  return (
    <div>

      <div
        style={{
          fontSize: "18px",
          fontWeight: "800",
          marginBottom: "14px",
          background: "linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text"
        }}
      >
        Formulir Laporan Warga
      </div>

      <div
        style={{
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          borderRadius: "16px",
          padding: "20px",
          boxShadow: "0 8px 24px rgba(30, 86, 49, 0.08)",
          border: "1px solid rgba(30, 86, 49, 0.08)",
          marginBottom: "24px"
        }}
      >

        <form onSubmit={handleSubmit}>

          <label style={{fontWeight:"600", color:"#5A6059", fontSize:"14px"}}>Nama Warga</label>

          <input
            style={{
              ...styles.input,
              background:"rgba(248, 250, 246, 0.6)",
              color:"#8A8F86"
            }}
            className="futuristic-input"
            value={house.nama}
            disabled
          />

          <label style={{fontWeight:"600", color:"#5A6059", fontSize:"14px"}}>Nomor Rumah</label>

          <input
            style={{
              ...styles.input,
              background:"rgba(248, 250, 246, 0.6)",
              color:"#8A8F86"
            }}
            className="futuristic-input"
            value={house.nomor_rumah}
            disabled
          />

          <label style={{fontWeight:"600", color:"#5A6059", fontSize:"14px"}}>Kategori</label>

          <select
            style={styles.input}
            className="futuristic-input"
            value={kategori}
            onChange={(e)=>setKategori(e.target.value)}
            required
          >

            <option value="">Pilih Kategori</option>

            <option>Keamanan</option>

            <option>Kebersihan</option>

            <option>Fasilitas Umum</option>

            <option>Jalan</option>

            <option>Lampu Jalan</option>

            <option>Saluran Air</option>

            <option>Lainnya</option>

          </select>

          <label style={{fontWeight:"600", color:"#5A6059", fontSize:"14px"}}>Judul Laporan</label>

          <input
            style={styles.input}
            className="futuristic-input"
            value={judul}
            onChange={(e)=>setJudul(e.target.value)}
            placeholder="Contoh : Lampu Jalan Mati"
            required
          />

          <label style={{fontWeight:"600", color:"#5A6059", fontSize:"14px"}}>Deskripsi</label>

          <textarea
            style={{
              ...styles.input,
              height:"120px",
              resize:"vertical"
            }}
            className="futuristic-input"
            value={deskripsi}
            onChange={(e)=>setDeskripsi(e.target.value)}
            placeholder="Tuliskan laporan secara lengkap..."
            required
          />

          <label style={{fontWeight:"600", color:"#5A6059", fontSize:"14px"}}>

            Upload Foto

          </label>

          <input
            type="file"
            accept="image/*"
            onChange={handleUploadFoto}
          />

          <div
            style={{
              fontSize:"12px",
              color:"#8A8F86",
              marginTop:"6px",
              marginBottom:"10px"
            }}
          >
            {uploading
              ? "Mengupload foto..."
              : foto
                ? "✅ Foto berhasil dipilih"
                : "Belum ada foto"}
          </div>

          <button
            style={styles.btnPrimary}
            className="neon-btn"
            disabled={uploading}
          >
            Kirim Laporan
          </button>

        </form>

        </div>

        <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "12px"
        }}
      >
        <div style={{fontSize: "18px", fontWeight: "800", background: "linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text"}}>
          Riwayat Laporan
        </div>
        <button
          type="button"
          onClick={muatRiwayat}
          disabled={isRefreshing}
          style={{
            background: "linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)",
            color: "#ffffff",
            border: "none",
            borderRadius: "10px",
            padding: "6px 12px",
            fontSize: "13px",
            fontWeight: "bold",
            cursor: isRefreshing ? "not-allowed" : "pointer",
            opacity: isRefreshing ? 0.7 : 1,
            boxShadow: "0 4px 12px rgba(30, 86, 49, 0.2)"
          }}
        >
          {isRefreshing ? "Memuat..." : "🔄 Refresh"}
        </button>
      </div>

      {riwayat.length === 0 ? (

        <div
          style={{
            background:"rgba(255, 255, 255, 0.6)",
            padding:"20px",
            borderRadius:"12px",
            textAlign:"center",
            color:"#8A8F86",
            border:"1px solid rgba(30, 86, 49, 0.08)"
          }}
        >
          Belum ada laporan.
        </div>

      ) : (

        riwayat.filter(item => !hiddenLaporan.includes(item.id)).map((item, idx)=>(

          <div
            key={item.id || idx}
            style={{
              background:"rgba(255, 255, 255, 0.8)",
              backdropFilter:"blur(12px)",
              WebkitBackdropFilter:"blur(12px)",
              borderRadius:"16px",
              padding:"16px",
              marginBottom:"14px",
              boxShadow:"0 4px 16px rgba(30, 86, 49, 0.08)",
              border:"1px solid rgba(30, 86, 49, 0.08)",
              position:"relative"
            }}
          >
            <button
              type="button"
              onClick={() => hideLaporan(item.id)}
              aria-label="Hapus riwayat"
              style={{
                position:"absolute",
                top:"10px",
                right:"10px",
                background:"rgba(194, 76, 76, 0.1)",
                border:"1px solid rgba(194, 76, 76, 0.25)",
                color:"#C24C4C",
                width:"30px",
                height:"30px",
                borderRadius:"50%",
                cursor:"pointer",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                transition:"all 0.2s ease"
              }}
              onMouseEnter={e => { e.currentTarget.style.background = "rgba(194, 76, 76, 0.2)"; e.currentTarget.style.transform = "scale(1.1)"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "rgba(194, 76, 76, 0.1)"; e.currentTarget.style.transform = "scale(1)"; }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            <div
              style={{
                fontWeight:"bold",
                color:"#1E5631",
                fontSize:"17px",
                marginBottom:"6px"
              }}
            >
              {item.judul}
            </div>

            <div style={{marginBottom:"6px", color:"#1E2A22"}}>
              📂 {item.kategori}
            </div>

            <div
              style={{
                marginBottom:"8px",
                whiteSpace:"pre-wrap",
                color:"#1E2A22"
              }}
            >
              {item.deskripsi}
            </div>

            <div
              style={{
                fontSize:"13px",
                color:"#8A8F86",
                marginBottom:"10px"
              }}
            >
              📅 {new Date(item.created_at).toLocaleDateString("id-ID")}
            </div>

            <div style={{marginBottom:"12px"}}>

              <StatusBadge
                status={item.status || "Menunggu Jawaban"}
              />

            </div>

            {item.balasan_admin && (

              <div
                style={{
                  background:"rgba(30, 86, 49, 0.06)",
                  borderLeft:"4px solid #1E5631",
                  padding:"12px",
                  borderRadius:"10px",
                  marginBottom:"12px",
                  border:"1px solid rgba(30, 86, 49, 0.1)",
                  borderLeftWidth:"4px"
                }}
              >

                <div
                  style={{
                    fontWeight:"bold",
                    marginBottom:"6px",
                    color:"#1E5631"
                  }}
                >
                  Balasan Pengurus
                </div>

                <div style={{color:"#1E2A22"}}>
                  {item.balasan_admin}
                </div>

              </div>

            )}

            {item.foto && (

              <a
                href={item.foto}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color:"#1E5631",
                  textDecoration:"none",
                  fontWeight:"bold"
                }}
              >
                📷 Lihat Foto
              </a>

            )}

          </div>

        ))

      )}

    </div>

  );

}